<template>
  <div>
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card v-if="visible" style="min-width: 50vw; padding: 32px">
            <v-card-title>
              <div primary-title>
                <h3 class="headline mb-0">
                  Actualizar <b>{{ type.replaceAll("_", " ") }}</b> de la
                  inscripción con id
                  <b>{{ idPerson }}</b>
                </h3>
                <br />
                <div>
                  Al volcar aquí el documento vas a actulizar la documentación
                  de una inscripción.
                </div>
              </div>
            </v-card-title>
            <v-container fluid grid-list-xl>
              <v-layout row wrap>
                <v-flex xs12 md12>
                  <file-input v-model="file"></file-input>
                </v-flex>
              </v-layout>
              <v-alert
                outline
                type="error"
                :value="error"
                transition="scale-transition"
              >
                Ha ocurrido un error, contacta con
                inscripcionesverano@scouts284.org.in
              </v-alert>
            </v-container>
          </v-card>
          <v-alert
            outline
            type="success"
            :value="!visible"
            transition="scale-transition"
          >
            Archivo actualizado💪! Revisa el cambio
          </v-alert>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import FileInput from "./formulario/FileInput";

export default {
  components: { FileInput },
  props: ["type", "idPerson"],
  data: () => ({
    file: null,
    visible: true,
    error: false,
  }),
  name: "inscripciones-recibo",
  watch: {
    file(val) {
      if (val) {
        var vue = this;

        //One method for every document type
        if (this.type == "seguridad_social") {
          this.$db
            .collection("forms")
            .doc("inscripciones")
            .collection("people")
            .doc(this.idPerson)
            .update({
              seguridad_social: val,
            })
            .then(function () {
              vue.visible = false;
            })
            .catch(function (error) {
              vue.error = true;
              console.error("Error writing document: ", error);
            });
        }

        if (this.type == "vacunas") {
          this.$db
            .collection("forms")
            .doc("inscripciones")
            .collection("people")
            .doc(this.idPerson)
            .update({
              cartilla_vacunacion: val,
            })
            .then(function () {
              vue.visible = false;
            })
            .catch(function (error) {
              vue.error = true;
              console.error("Error writing document: ", error);
            });
        }

        if (this.type == "autorizacion") {
          this.$db
            .collection("forms")
            .doc("inscripciones")
            .collection("people")
            .doc(this.idPerson)
            .update({
              autorizacion: val,
            })
            .then(function () {
              vue.visible = false;
            })
            .catch(function (error) {
              vue.error = true;
              console.error("Error writing document: ", error);
            });
        }

        if (this.type == "otros_archivos_medicos") {
          this.$db
            .collection("forms")
            .doc("inscripciones")
            .collection("people")
            .doc(this.idPerson)
            .update({
              docs: val,
            })
            .then(function () {
              vue.visible = false;
            })
            .catch(function (error) {
              vue.error = true;
              console.error("Error writing document: ", error);
            });
        }
      }
    },
  },
};
</script>

<style scoped>
</style>